/**
 * Juno Product Grid - Smart Video Autoplay
 * Desktop: Autoplay immediately after short delay
 * Mobile/Tablet: Autoplay when scrolled into view (Intersection Observer)
 */

(function () {
    'use strict';

    // Configuration
    const DESKTOP_AUTOPLAY_DELAY = 500; // 500ms delay for desktop
    const MOBILE_BREAKPOINT = 1024; // Below this = mobile/tablet

    /**
     * Check if device is mobile/tablet
     */
    function isMobileOrTablet() {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }

    /**
     * Play a video element (simplified to match theme's approach)
     */
    function playVideo(video) {
        // Only play if it's a muted video (not modal videos)
        const videoStyle = video.getAttribute('data-video-style');
        if (videoStyle === 'unmuted') {
            return; // Skip unmuted videos - they should use the modal
        }

        // Simple play like the theme does
        var playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise.then(function () {
                // Playing as expected
            }).catch(function (error) {
                // Autoplay was prevented
                console.log('Video autoplay prevented:', error);
            });
        }
    }

    /**
     * Pause a video element
     */
    function pauseVideo(video) {
        if (!video.paused) {
            video.pause();
        }
    }

    /**
     * Desktop: Immediate autoplay after delay
     */
    function initDesktopAutoplay(videos) {
        setTimeout(function () {
            videos.forEach(function (video) {
                playVideo(video);
            });
        }, DESKTOP_AUTOPLAY_DELAY);
    }

    /**
     * Mobile/Tablet: Scroll-based autoplay using Intersection Observer
     */
    function initScrollBasedAutoplay(videos) {
        // Check if Intersection Observer is supported
        if (!('IntersectionObserver' in window)) {
            // Fallback: play all videos immediately
            videos.forEach(function (video) {
                playVideo(video);
            });
            return;
        }

        // Create observer
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                const video = entry.target;

                if (entry.isIntersecting) {
                    // Video is visible - play it
                    playVideo(video);
                } else {
                    // Video is not visible - pause it to save resources
                    pauseVideo(video);
                }
            });
        }, {
            // Trigger when 50% of video is visible
            threshold: 0.5,
            // Start observing slightly before video enters viewport
            rootMargin: '50px'
        });

        // Observe all videos
        videos.forEach(function (video) {
            observer.observe(video);
        });
    }

    /**
     * Initialize video autoplay based on device type
     */
    function initVideoAutoplay() {
        // Find all video elements with data-video-style="muted"
        const videos = Array.from(document.querySelectorAll('video[data-video-style="muted"]'));

        if (videos.length === 0) {
            return;
        }

        // Choose strategy based on device
        if (isMobileOrTablet()) {
            // Mobile/Tablet: Scroll-based autoplay
            initScrollBasedAutoplay(videos);
        } else {
            // Desktop: Immediate autoplay
            initDesktopAutoplay(videos);
        }
    }

    /**
     * Re-initialize on window resize (if user rotates device or resizes browser)
     */
    let resizeTimeout;
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            initVideoAutoplay();
        }, 250);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoAutoplay);
    } else {
        initVideoAutoplay();
    }

    // Also try after a delay to ensure theme JS has loaded
    setTimeout(initVideoAutoplay, 1000);

    // Re-initialize when variant changes (for color variants with different videos)
    document.addEventListener('variant:change', function () {
        setTimeout(initVideoAutoplay, 500);
    });

    // Re-initialize on window resize
    window.addEventListener('resize', handleResize);
})();
